import React, { useState } from "react";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";

import { messages } from "../Preparations.messages";
import styles from "./SoftwareRequirements.module.scss";
import { Slide1 } from "./slides/Slide1/Slide1";
import { Slide2 } from "./slides/Slide2/Slide2";
import { Slide3 } from "./slides/Slide3/Slide3";

export const SoftwareRequirements: React.FC = () => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);

  const renderSlide = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return <Slide1 />;
      case 1:
        return <Slide2 />;
      case 2:
        return <Slide3 />;
      default:
        return <Slide1 />;
    }
  };

  return (
    <div className={styles.content}>
      {renderSlide()}
      <div className={styles.switchOption}>
        <SwitchOption
          onClick={setSelectedOption}
          activeItem={selectedOption}
          items={[
            {
              name: formatMessage(messages.softwareRequirementsOption1),
            },
            {
              name: formatMessage(messages.softwareRequirementsOption2),
            },
            {
              name: formatMessage(messages.softwareRequirementsOption3),
            },
          ]}
        />
      </div>
    </div>
  );
};
